/*Sidebar*/

import i_vias from './../UI/icons/Sidebar/Vias2.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias.svg'
import i_beneficios from './../UI/icons/Sidebar/Puntos-interes2.svg'
import i_beneficios2 from './../UI/icons/Sidebar/Puntos-interes.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades2.svg'
import i_etapas from './../UI/icons/Sidebar/Proyecto2.svg'
import i_etapas2 from './../UI/icons/Sidebar/Proyecto.svg'

import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Amenities*/

import i_lobby from './../UI/icons/Amenities/Lobby.svg'
import i_hobbies from './../UI/icons/Amenities/Hobbies.svg'
import i_bicicletero from './../UI/icons/Amenities/bicicletero.svg'
import i_gym from './../UI/icons/Amenities/Gym.svg'
import i_saladejuegos from './../UI/icons/Amenities/salonjuegos.svg'
import i_saloncomunal from './../UI/icons/Amenities/saloncomunal.svg'
import i_bbq from './../UI/icons/Amenities/BBQ.svg'
import i_commercialarea from './../UI/icons/Amenities/CommercialArea.svg'
import i_biosaludables from './../UI/icons/Amenities/biosaludable.svg'

import i_lobby2 from './../UI/icons/Amenities/Lobby2.svg'
import i_hobbies2 from './../UI/icons/Amenities/Hobbies2.svg'
import i_bicicletero2 from './../UI/icons/Amenities/bicicletero2.svg'
import i_gym2 from './../UI/icons/Amenities/Gym2.svg'
import i_saladejuegos2 from './../UI/icons/Amenities/salonjuegos2.svg'
import i_saloncomunal2 from './../UI/icons/Amenities/saloncomunal2.svg'
import i_bbq2 from './../UI/icons/Amenities/BBQ2.svg'
import i_commercialarea2 from './../UI/icons/Amenities/CommercialArea2.svg'
import i_biosaludables2 from './../UI/icons/Amenities/biosaludable2.svg'

/*POIS*/
import i_salud from './../UI/icons/POI/Salud.svg'
import i_comercio from './../UI/icons/POI/Comercio.svg'
import i_transporte from './../UI/icons/POI/Transporte.svg'
import i_otros from './../UI/icons/POI/Otros.svg'
import i_colegios from './../UI/icons/POI/Educacion.svg'
import i_parques from './../UI/icons/POI/Parques.svg'
import i_educacion from './../UI/icons/POI/Educacion.svg'

import i_salud2 from './../UI/icons/POI/Salud2.svg'
import i_comercio2 from './../UI/icons/POI/Comercio2.svg'
import i_transporte2 from './../UI/icons/POI/Transporte2.svg'
import i_otros2 from './../UI/icons/POI/Otros2.svg'
import i_colegios2 from './../UI/icons/POI/Educacion2.svg'
import i_parques2 from './../UI/icons/POI/Parques2.svg'
import i_educacion2 from './../UI/icons/POI/Educacion2.svg'

export default {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,

    /*Amenidades*/
    'Portería': i_lobby,
    'Portería2': i_lobby2,
    'Salón Infantil': i_hobbies,
    'Salón Infantil2': i_hobbies2,
    'Bicicleteros': i_bicicletero,
    'Bicicleteros2': i_bicicletero2,
    'Espacios para Gimnasio': i_gym,
    'Espacios para Gimnasio2': i_gym2,
    'Salón Juvenil': i_saladejuegos,
    'Salón Juvenil2': i_saladejuegos2,
    'Salón comunal': i_saloncomunal,
    'Salón comunal2': i_saloncomunal2,
    'Zona BBQ': i_bbq,
    'Zona BBQ2': i_bbq2,
    'Zona Comercial': i_commercialarea,
    'Zona Comercial2': i_commercialarea2,
    "Zona de parques": i_parques,
    "Zona de parques2": i_parques2,
    "Zona con máquinas de ejercicios": i_biosaludables,
    "Zona con máquinas de ejercicios2": i_biosaludables2,

    /*POIS*/
    "Salud": i_salud,
    "Salud2": i_salud2,
    "Comercio": i_comercio,
    "Comercio2": i_comercio2,
    "Transporte": i_transporte,
    "Transporte2": i_transporte2,
    "Otros": i_otros,
    "Otros2": i_otros2,
    "Colegios": i_colegios,
    "Colegios2": i_colegios2,
    "Parques": i_parques,
    "Parques2": i_parques2,
    "Educación": i_educacion,
    "Educación2": i_educacion2,
}